import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/ui/Icons';

import { StyledDelay, StyledDisruptionAnchor } from './TrainDisruption.styles';

const TrainDisruptionWarning = ({ disruption, tooltipId }) => {
  if (!disruption) {
    return null;
  }

  const { delayMinutes, trainNumber } = disruption;

  return (
    <StyledDisruptionAnchor data-for={tooltipId} data-tip={trainNumber} data-testid={`train-disruption-${trainNumber}`} tabIndex={0}>
      <Icon icon="WarningTriangle" />
      {delayMinutes !== null && <StyledDelay data-testid={`train-disruption-delay-${trainNumber}`}>{`+${delayMinutes}'`}</StyledDelay>}
    </StyledDisruptionAnchor>
  );
};

TrainDisruptionWarning.propTypes = {
  disruption: PropTypes.shape({
    trainNumber: PropTypes.string,
    delayMinutes: PropTypes.number,
    news: PropTypes.arrayOf(PropTypes.object)
  }),
  tooltipId: PropTypes.string
};

export default TrainDisruptionWarning;
